import { Component, OnInit } from "@angular/core";
import { ApiServiceService } from "src/app/core/api-service/api-service";
import { AlertNotification } from "src/app/core/alertnotification/alertNotification";
// import { FirebaseQueryService } from 'src/app/core/api-service/firebase-query';
import { NgxSpinnerService } from "ngx-spinner";
import { FirebaseQueryService } from "src/app/core/api-service/firebase-query";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  statsValue: any = {};

  constructor(
    private apiservice: ApiServiceService,
    private alertnotification: AlertNotification,
    private firebaseservice: FirebaseQueryService,
    private loaderService: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.getUserlist();
    this.getPardnasList();
    this.getPaymentsList();
  }

  getPardnasList() {
    try {
      var records1 = [];
      this.firebaseservice
        .getPardna()
        .then(
          function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              var data = doc.data();
              data["id"] = doc.id;
              records1.push(data);
            });
            this.statsValue["pardnas"] = records1.length;
            this.loaderService.hide();
          }.bind(this)
        )
        .catch(
          function (error) {
            this.loaderService.hide();
            console.log("Error getting documents: ", error);
          }.bind(this)
        );
    } catch (error) {
      this.loaderService.hide();
      console.log(error);
    }
  }

  getUserlist() {
    try {
      var records1 = [];
      this.firebaseservice
        .getUsers()
        .then(
          function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              var data = doc.data();
              data["id"] = doc.id;
              records1.push(data);
            });
            this.statsValue["users"] = records1.length;
            this.loaderService.hide();
          }.bind(this)
        )
        .catch(
          function (error) {
            this.loaderService.hide();
            console.log("Error getting documents: ", error);
          }.bind(this)
        );
    } catch (error) {
      this.loaderService.hide();
      console.log(error);
    }
  }

  getPaymentsList() {
    try {
      var payments = [];
      this.firebaseservice
        .getPayments()
        .then(
          function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              var data = doc.data();
              data["id"] = doc.id;
              payments.push(data);
            });
            this.statsValue["payments"] = payments.length;
            this.loaderService.hide();
          }.bind(this)
        )
        .catch(
          function (error) {
            this.loaderService.hide();
            console.log("Error getting documents: ", error);
          }.bind(this)
        );
    } catch (error) {
      this.loaderService.hide();
      console.log(error);
    }
  }
}
